import type { WaterProfile } from "../types";
import { PROFILES, MAT_LABEL, MAT_DESC, MAT_IMAGE, MATERIALS_HEADING } from "../profiles";
import { assetUrl } from "../assets";

export function MaterialsList({ profileKey }: { profileKey: WaterProfile }) {
  // Only materials with an image render (Maifan has none -> dropped).
  const keys = PROFILES[profileKey].materials.filter((k) => MAT_IMAGE[k]);
  return (
    <div className="materials reveal">
      <div className="materials-h">{MATERIALS_HEADING}</div>
      <div className="matlist">
        {keys.map((k) => (
          <div className="mrow" key={k}>
            <img src={assetUrl(MAT_IMAGE[k])} alt={MAT_LABEL[k]} />
            <div className="mrt">
              <div className="mr-name">{MAT_LABEL[k]}</div>
              <div className="mr-desc">{MAT_DESC[k]}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
